module.exports = __webpack_public_path__ + "static/media/AVISOIMPORTANTEdiciembre2026.1bfd2f30.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/AVISOIMPORTANTEdiciembre2026.pdf
// module id = 969
// module chunks = 0